export default __webpack_public_path__ + "static/media/SWT1990.34I-42359_-25413_0.02918906.jpg";